// @ts-nocheck
import { useGet } from 'hooks';
import useSaveAttachment from 'hooks/useSaveAttachment';

const useAttachment = () => {
  const {
    data: attachmentData,
    loading: loadingAttachmentData,
    fetch: fetchAttachmentData,
  } = useGet(`/attachment/get_multiple_urls/`, {
    skip: true,
  });

  const {
    saveAttachmentFile: saveAttachment,
    isSaveFileLoading: attachmentLoading,
  } = useSaveAttachment();
  const stripPrefixInAttachmentID = (attachmentId: string): string =>
    attachmentId?.replace(/^item-/, '');

  const getFormData = (files) => {
    const formData = new FormData();
    if (files instanceof Blob) {
      formData.append('files', files);
    } else if (files && (Array.isArray(files) || typeof files === 'object')) {
      Object.values(files).forEach((file) => {
        formData.append('files', file);
      });
    } else {
      formData.append('files', files);
    }
    return formData;
  };
  const removeSurroundingQuotes = (id) => id.replace(/^"|"$/g, '');

  return {
    attachmentData,
    attachmentLoading,
    loadingAttachmentData,
    saveAttachment,
    fetchAttachmentData,
    stripPrefixInAttachmentID,
    getFormData,
    removeSurroundingQuotes,
  };
};

export default useAttachment;
